import styled from 'styled-components';
import { Text14Bold } from '../../components/utils/Text/Text.styles';

export const ReelViewport = styled.div`
  position: relative;
  height: 100%;
`;

export const ReelStage = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background: transparent;
  overflow: hidden;

  @media (min-width: 768px) {
    width: min(100%, 55rem);
  }
`;

export const FeedScroller = styled.div`
  height: 100%;
  overflow-y: auto;
  scroll-snap-type: y mandatory;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const LoaderContainer = styled.div`
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EmptyState = styled(Text14Bold)`
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 2.4rem;
  color: rgba(255, 255, 255, 0.75);
`;
